<!-- Fullscreen overlay -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
  <!-- Content box -->
  <div class="rounded-xl shadow-2xl w-full max-w-2xl md:max-w-3xl p-8 md:p-12 text-center relative"
    [style.background-image]="'url(' + background + ')'" style="background-size: cover; background-position: center;">
    <!-- Close button -->
    <button 
      (click)="close()" 
      class="absolute top-4 right-4 md:top-6 md:right-6 bg-white rounded-full p-2 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-transparent transition-colors z-10 hover:bg-gray-100"
      aria-label="Close modal">
      <svg class="w-6 h-6 md:w-8 md:h-8 text-red-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
    <!-- Main heading -->
    <h2 class="text-3xl md:text-5xl font-extrabold text-white mb-4 font-dunbar">
      Congrats!
    </h2>

    <!-- Subheading -->
    <div class="flex flex-col items-center justify-center">
      <p class="text-3xl md:text-5xl text-white font-dunbar">
        You've unlocked
      </p>

      <div class="flex items-center justify-center gap-2 inline-block m-0 p-0">
        <p class="text-white text-4xl md:text-5xl inline-block font-extrabold font-dunbar"> {{ discountText }}</p>
        <p class="text-white text-4xl md:text-5xl inline-block font-dunbar">sitewide</p>
      </div>
    </div>

    <!-- Banner image -->
    <img [src]="banner" alt="Products" class="mx-auto w-full max-w-3xl h-auto object-contain m-0 p-0" />

    <!-- Call to action text -->
    <div class="flex items-center justify-center bg-white rounded-full flex-col m-0 p-2 w-full md:w-3/4 mx-auto">
      <p class="text-lg sm:text-2xl md:text-3xl text-principal font-bold sm:font-extrabold font-dunbar marginBotMinusEight">
        Add your favorites to the cart <br>
      </p>
      <p class="text-lg sm:text-2xl md:text-3xl text-principal font-bold sm:font-extrabold font-dunbar">
        and enjoy the deal!
      </p>
    </div>

    <!-- Red Numbers logo -->
    <img [src]="logo" alt="Red Numbers Coffee Co." class="mx-auto w-48 h-auto mt-6" />

    <!-- Close button - clicking anywhere on the modal content will close it -->
    <!-- <div (click)="close()" class="cursor-pointer inline-block px-8 py-3 bg-red-600 hover:bg-red-700 text-white text-lg rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition mt-6">
        Shop Now
    </div> -->
  </div>
</div>